import {
  colorBiText,
  colorForGrayBackground,
  colorForLightGrayBackground,
  colorLightGray9,
  colorProductDisabled,
  colorProductPrimary,
  colorProductPrimaryHover,
  colorRed3,
  colorRed6,
  colorSecondaryHover,
  colorWhite,
  primaryColor,
  primaryDisabledColor,
  primaryHoverColor,
  primaryTextColor,
  secondary1Color,
  secondary1TextColor,
  secondary2Color,
  secondaryDisabledColor,
  secondaryHoverColor,
  whiteColor
} from '../styles/globalVariables';
import { css } from 'styled-components/macro';

export const updateTheme = (
  primary: string = '',
  primaryDisabled: string = '',
  primaryHover: string = '',
  primaryText: string = '',
  secondary1: string = '',
  secondary1Text: string = '',
  secondary2: string = '',
  secondaryDisabled: string = '',
  secondaryHover: string = ''
): any => {
  return {
    primaryAppColor: primary ? primary : primaryColor,
    primaryTextColor: primaryText ? primaryText : primaryTextColor,
    whiteAppColor: whiteColor,
    primaryHover: primaryHover //TODO
      ? primaryHover
      : primaryHoverColor,
    primaryDisabled: primaryDisabled ? primaryDisabled : primaryDisabledColor,
    secondary1: secondary1 ? secondary1 : secondary1Color,
    secondary1Text: secondary1Text ? secondary1Text : secondary1TextColor,
    secondary2: secondary2 ? secondary2 : secondary2Color,
    secondaryHover: secondaryHover ? secondaryHover : secondaryHoverColor,
    secondaryDisabled: secondaryDisabled ? secondaryDisabled : secondaryDisabledColor,

    breadcrumbTextColor: `rgb(${colorLightGray9})`,

    sidebarBtnHoverBgColor: secondaryHover ? secondaryHover : secondaryHoverColor,
    sidebarBtnHoverTextColor: secondary1Text ? secondary1Text : secondary1TextColor,
    bgPrimaryStyleColor: {
      backgroundColor: primary ? primary : primaryColor,
      color: primaryText ? primaryText : primaryTextColor
    },
    secondaryButton: {
      border: `1px solid ${primary ? primary : primaryColor}`,
      color: `${primary ? primary : primaryColor}`,
      backgroundColor: `${whiteColor}`
    },
    tertiaryButton: {
      color: `${primary ? primary : primaryColor}`,
      border: 'none'
    },
    bgPrimaryStyleStriveColor: {
      backgroundColor: primary ? primary : primaryColor
    },
    bgColorStyleForLoggedInPage: {
      backgroundColor: secondary1 ? secondary1 : `rgb(${colorForLightGrayBackground})`
    },

    themeTextStyleColor: {
      color: primary ? primary : primaryColor
    },
    bgColorStyleForLoginPage: {
      backgroundColor: primary ? primary : primaryColor
    },

    bgHoverTextWhiteStyleColor: { color: primaryText || primaryTextColor },
    signInBtnStyle: {
      primary: css`
        background-color: ${primary ? primary : primaryColor};
        color: ${primaryText || primaryTextColor};
        border: 1px solid ${primary ? primary : primaryColor};

        &:hover {
          background-color: ${primaryHover ? primaryHover : primaryHoverColor};
        }

        &:disabled {
          background-color: ${primaryDisabled ? primaryDisabled : primaryDisabledColor};
          color: ${primaryText || primaryTextColor};
          border: 1px solid ${primary ? primary : primaryColor};

          &:hover {
            background-color: ${primaryDisabled ? primaryDisabled : primaryDisabledColor};
            color: ${primaryText || primaryTextColor};
            border: 1px solid ${primaryDisabled ? primaryDisabled : primaryDisabledColor};
          }
        }
      `,
      secondary: css`
        background-color: ${secondary1 ? secondary1 : secondary1Color};
        color: ${secondary1Text ? secondary1Text : `rgb(${secondary1TextColor})`};
        border: 1px solid ${secondary1 ? secondary1 : `rgb(${colorProductDisabled})`};

        &:hover {
          background-color: rgb(${colorSecondaryHover});
          color: ${secondary1 ? primaryHover : `rgb(${colorProductPrimaryHover})`};
          border: 1px solid ${secondary1 ? primaryHover : `rgb(${colorProductPrimaryHover})`};
        }

        &:disabled {
          background-color: rgb(${colorWhite});
          color: ${secondary1 ? secondary1 : `rgb(${colorProductDisabled})`};
          &:hover {
            background-color: rgb(${colorWhite});
            border: 1px solid ${secondary1 ? secondary1 : `rgb(${colorProductDisabled})`};
            color: ${secondary1 ? secondary1 : `rgb(${colorProductDisabled})`};
          }
        }
      `,
      tertiary: css`
        color: ${primary ? primary : `rgb(${colorProductPrimary})`};
        background-color: rgb(${colorWhite});

        &:hover {
          color: ${secondary1 ? primaryHover : `rgb(${colorProductPrimaryHover})`};
        }

        &:disabled {
          color: ${secondary1 ? secondary1 : `rgb(${colorProductDisabled})`};
          &:hover {
            background-color: rgb(${colorWhite});
            color: ${secondary1 ? secondary1 : `rgb(${colorProductDisabled})`};
          }
        }
      `,
      danger: css`
        background-color: rgb(${colorWhite});
        color: rgb(${colorRed6});
        border: 1px solid rgb(${colorRed6});

        &:hover {
          background-color: rgb(${colorRed3});
        }

        &:disabled {
          border: 1px solid rgb(${colorRed3});
          color: rgb(${colorRed3});
          &:hover {
            background-color: rgb(${colorWhite});
            border: 1px solid rgb(${colorRed3});
            color: rgb(${colorRed3});
          }
        }
      `
    },
    secondaryHoverBgColor: {
      backgroundColor: secondary1 ? secondary1 : `rgb(${colorSecondaryHover})`
    },
    bgColorForMyAccountPage: {
      backgroundColor: secondary1 ? secondary1 : `rgb(${colorForGrayBackground})`
    },
    bgPrimaryDisabledStyleColor: {
      backgroundColor: primaryDisabled ? primaryDisabled : primaryDisabledColor
    }
  };
};
